import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNetlifyComponent } from './simple-icons-netlify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNetlifyComponent ],
    exports:      [ SimpleIconsNetlifyComponent ],
    bootstrap:    []
})
export class SimpleIconsNetlifyModule {}
